// extracted by mini-css-extract-plugin
export default {"btnRow":"ozhbRC3QH_DiIRLeJzSj"};